<script lang="ts">
export type CountryField = Pick<CountryOption, 'countryCode' | 'taxIdMandatory'>;
</script>
<script setup lang="ts">
import lodashPick from 'lodash-es/pick';

// COMPOSABLES
const { countries } = useCountries();
const { tt } = useTypedI18n();

// MODEL
const model = defineModel<CountryField | undefined>({ required: true });

const inputModel = computed<CountryOption | undefined>({
    get() {
        return countries.value.find(c => c.countryCode === model.value?.countryCode);
    },
    set(newValue: CountryOption | undefined) {
        model.value = newValue && lodashPick(newValue, ['countryCode', 'taxIdMandatory']);
    },
});
</script>

<template>
    <USelectMenu v-model="inputModel" :items="countries" :search-input="{ placeholder: tt('common.searchPlaceholder') }">
        <template #empty="{ searchTerm: query }">
            <span>{{ tt('common.searchNoResults', { query }) }}</span>
        </template>
    </USelectMenu>
</template>
